import { environment, formatDate, getOnlineServices, sleep } from "../util/index";
import { indexDBStorage } from "../storage/indexDBStorage";
import RequestService from "../util/request";
import { useDispatch, useSelector } from "react-redux";
import { createFailureAction, createSetViewAction, createUpdatePreChacheValidationStatusAction, createUpdateProgressAction } from "state/reducer";
import { IADPState} from "../Types/AppStateTypes";
import { UpdateRequest, SoftwareUpdateStatusRequest, Manifest } from "../Types//ServiceTypes";

const logPrefix = "[ADPClient][UpdatesServiceHook]"

export function useUpdatesService() {
  const dispatch = useDispatch()
  const state = useSelector((state:{rootState:IADPState}) => state.rootState)
  async function resetSW() {
    let promises = [];
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      promises.push(reg.unregister());
    }
    await Promise.all(promises).finally(() => {
      dispatch(createUpdatePreChacheValidationStatusAction({validationStatus:"Pending",
      validationDetails:`Reseting service workers and reloading window`})); 
      setTimeout((()=>{
        //window.location.reload();
      }),2000);
    });
  }
    async function FetchReleaseManifest(onSoftwareUpdateResponse:(response:any)=>void){
      const onlineServiceConfig = getOnlineServices(state.appState.configuration);
      const versionPayload:UpdateRequest = {
        "environment": state.appState.environment || "dev",
        "product": "enaep",
        "appCode": "ng-enaep-secure-browser",
        "targetedOS": "chromeOS",
        "locale": "en-US",
        "installedVersion": state.appState.releaseVersion || "",
        "targetedVersion": "",
        "targetedBuildNumber": "",
        "buildNumber": state.appState?.releaseBuildNumber?.toString(),
        "clientDetails": {
          "ip": state.sessionState.networkDetails?.address || "127.0.0.1",
          "macAddress": state.sessionState.networkDetails?.address || "127.0.0.1",
          "deviceDetails": {
              "deviceType": state.deviceState.deviceType || "SBE",
              "deviceName":state.deviceState.deviceId  || "Chromebook"
          }
      }
      };
      const url = `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.softwareUpdate}`;
      RequestService.postSoftwareUpdateInquiry(versionPayload,url, onSoftwareUpdateResponse);
      return;
    }
    const updateStatusPayload =(taskStatus:"SUCCESS" | "FAILURE")=> {
      const payload: SoftwareUpdateStatusRequest = {
       context:{
         path: `diagnostic/ng-enaep-student-app/${state.deviceState?.deviceType?.toLocaleLowerCase() || "sbe"}/p1/software-update-status/${state.deviceState?.deviceId}` ,  
         fileName:`ADP_PWA_UPDATE_${taskStatus}_${formatDate(new Date(),true)}.json`,  
       },
        data:{
         schemaVersion: '1.0.1',
         releaseVersion: state.appState?.releaseVersion || "",
         buildNumber: state.appState?.releaseBuildNumber || 0,
         appVersion: state.appState?.appVersion,
         appType: 'ng-enaep-adp-pwa',
         deviceDetails: {
           deviceType:state.deviceState?.deviceType || "SBE",
           deviceName: state.deviceState?.deviceId  || "Chromebook",
           deviceModel: state.deviceState?.deviceModel  || "Chromebook",
           hostingPlatform: state.appState?.runtimePlatform?.userAgent
         },
         sessionDetails: {
           clientLaunchId: state.appState?.appLaunchId as string,
           adpLaunchDateTime:state.appState.appLaunchTime as unknown as Date,
           setupCode:'NotAvailable',
           participantId: 'NotAvailable',
           assessmentDeliveryMode: state.sessionState?.selectedAssessmentMode
         },
         updateDetails: {
           updateType: "ADP-PWA-Update",
           updateStartDateTime: new Date().toISOString(),
           updateEndDateTime:new Date().toISOString(),
           updateExecutionTime: 0,
           updateStatus: taskStatus,
           newReleaseVersion: "",
           appComponents:[]
        } 
       }
      }
       
      return payload;
    
   }
    async function OnUpdateError(reason: string, manifest?: Manifest){
      const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","updateRecord");
      console.error(logPrefix, `update failed after ${updateRecord?.updateAttempts} attempts`);
      const onlineServiceConfig = getOnlineServices(state.appState.configuration);
      let payload = updateStatusPayload("FAILURE");
      payload.data.releaseVersion = updateRecord?.localVersion;
      payload.data.updateDetails.newReleaseVersion = 'FailedToUpdate';
      payload.data.updateDetails.updateEndDateTime =new Date().toISOString();
      payload.data.updateDetails.updateStartDateTime =updateRecord?.updateStartTime;
      payload.data.updateDetails.updateExecutionTime = updateRecord ? Date.now()-updateRecord?.timestamp : 0;
      payload.data.updateDetails.appComponents = state.updateState?.appComponentVersions;
      payload.data.updateDetails.updateFailure ={
        currentReleaseVersion:  payload.data.releaseVersion,
        currentBuildVersion:  payload.data.buildNumber?.toString(),
        targetedReleaseVersion: manifest?.manifest?.product?.version || "unknown",
        targetedBuildVersion: manifest?.manifest?.product?.buildNumber || "unknown",
        reasons: [{
          componentName: "adp-pwa",
          componentVersion: state.appState?.appVersion,
          error: reason
        }]
    };
      RequestService.postSoftwareUpdateStatus(payload, `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.softwareStatus}`).then(async ()=>{
        console.info(logPrefix,"software status update posted");
      }).catch(async (e)=>{
        console.error(logPrefix,"failed to post software status", e);
        (await indexDBStorage.getInstance()).transactions.put("adp-session-references",({payload:payload, error:JSON.stringify(e),attempts:updateRecord?.updateAttempts}),`${state.appState.appLaunchId}-updateStatusFailure`); 
        (await indexDBStorage.getInstance()).transactions.put("adp-session-references",({payload:payload, error:reason,attempts:updateRecord?.updateAttempts}),`${state.appState.appLaunchId}-updateFailure`); 
          }).finally(async ()=>{
            //reset count
          (await indexDBStorage.getInstance()).transactions.put("adp-session-references",{localVersion:state.appState?.releaseVersion,updateAttempts:0},"updateRecord");
          dispatch(createFailureAction("UpdateError"));
           });
    }
    async function ReleaseStatus(){
      return new Promise(async ():Promise<void> => {
      try {
        const onSoftwareUpdateResponse = async (response:any)=>{
         
          const manifest: Manifest = response;
          const onlineServiceConfig = getOnlineServices(state.appState.configuration);
          console.log(logPrefix, "release status", manifest.infoCode);
          const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","updateRecord");
         if(response.error){
          if(updateRecord?.updateAttempts > 3){
              await OnUpdateError(`Error: ${response?.error?.message}, update failed after ${updateRecord?.updateAttempts} attempts`);
              return;
           }
           else {
            //store update attempts
            (await indexDBStorage.getInstance()).transactions.put("adp-session-references",
          {localVersion:state.appState?.releaseVersion,newVersion:manifest.manifest?.product?.version,timestamp:Date.now(),
            updateStartTime:updateRecord?.updateStartTime ? updateRecord?.updateStartTime : new Date().toISOString(),
            updateAttempts:updateRecord?.updateAttempts ? updateRecord?.updateAttempts+1 : 1, error:response?.error?.message},"updateRecord");
            //retry software update
           await sleep(500);
           await FetchReleaseManifest(onSoftwareUpdateResponse);
           }
          return;
        }
       if(manifest.infoCode=== "INFO-6001"){
          if(state.appState.releaseVersion === manifest.manifest?.product?.version){
            console.log(logPrefix, "no new release available", {localVersion:state.appState.releaseVersion, releaseVersion:manifest.manifest?.product?.version});
            const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","updateRecord");
            //post success after at least one attempt
            if(!updateRecord || updateRecord?.updateAttempts > 0){
              if(!updateRecord){
                console.info(logPrefix, "No update records in the IndexDB, considered as new installation, post update status");
               }
              else {
                console.log(logPrefix, "posting update status after success update", {localVersion:state.appState.releaseVersion, releaseVersion:manifest.manifest?.product?.version});
                dispatch(createUpdateProgressAction({type: "update-not-available"}));
              } 
              const payload = updateStatusPayload("SUCCESS");
              payload.data.releaseVersion = updateRecord?.localVersion;
              payload.data.updateDetails.newReleaseVersion = manifest.manifest?.product?.version;
              payload.data.updateDetails.updateEndDateTime = new Date().toISOString();
              payload.data.updateDetails.updateStartDateTime =updateRecord?.updateStartTime;
              payload.data.updateDetails.updateExecutionTime = updateRecord ? Date.now()-updateRecord?.timestamp : 0;
              payload.data.updateDetails.appComponents = {...state.serviceWorkers,...state.cacheValidation}
               RequestService.postSoftwareUpdateStatus(payload, `${environment.resolveApiDomain(state.appState.configuration)}/${onlineServiceConfig?.softwareStatus}`).then(async ()=>{
                console.info(logPrefix," Software status posted");
               }).catch(async (e)=>{
                console.error(logPrefix,"failed to post software status", e);
                (await indexDBStorage.getInstance()).transactions.put("adp-session-references",JSON.stringify({payload:payload, error:JSON.stringify(e) }),"updateStatusFailure");
               }).finally(async ()=>{
                (await indexDBStorage.getInstance()).transactions.put("adp-session-references",{localVersion:state.appState.releaseVersion,updateAttempts:0},"updateRecord"); 
                await sleep(500);
                dispatch(createSetViewAction("ModeSelectionsView"));
               });
            }
            else {
              dispatch(createSetViewAction("ModeSelectionsView"));
            }
           }
           else {
            //dispatch(createSetReleaseVersionAction(manifest))
            console.log(logPrefix, " update available", {localVersion:state.appState?.releaseVersion, updateStartTime: new Date().toISOString(),releaseVersion:manifest.manifest?.product?.version});
            //store update progress in DB
            const updateRecord = await (await indexDBStorage.getInstance()).transactions.get("adp-session-references","updateRecord");
            if(!updateRecord?.updateAttempts || updateRecord?.updateAttempts === 0){
              dispatch(createUpdateProgressAction({type: "update-available"}));
              await sleep(500);
              dispatch(createUpdateProgressAction({type: "update-ready"}));
            }
            else {
              dispatch(createUpdateProgressAction({type: "update-ready"}));
            };
            if(updateRecord?.updateAttempts === -1){
            console.log("attempt to reset cache");
                await resetSW();
           }
           else if(updateRecord?.updateAttempts > 2){
               OnUpdateError(`release version mismatch, update failed after ${updateRecord?.updateAttempts} attempts`,manifest);
               return;
            }
            (await indexDBStorage.getInstance()).transactions.put("adp-session-references",
            {localVersion:state.appState?.releaseVersion,newVersion:manifest.manifest?.product?.version,timestamp:Date.now(),
              updateStartTime:updateRecord?.updateStartTime ? updateRecord?.updateStartTime : new Date().toISOString(),
              updateAttempts:updateRecord?.updateAttempts ? updateRecord?.updateAttempts+1 : 1,error: `release version mismatch, update failed after ${updateRecord?.updateAttempts} attempts`},"updateRecord");
             //retry software update
             await (await indexDBStorage.getInstance()).transactions.delete("adp-session-references","localReleaseVersion");
             await sleep(500);
             window.location.reload();
           }
            return;
          }
          else {
            (await indexDBStorage.getInstance()).transactions.put("adp-session-references",{localVersion:state.appState.releaseVersion,updateAttempts:0},"updateRecord");
            await sleep(500);
            dispatch(createUpdateProgressAction({type: "update-not-available"}));
            await sleep(500);
            dispatch(createSetViewAction("ModeSelectionsView"));
          return;
          }
        }
        FetchReleaseManifest(onSoftwareUpdateResponse)
      }
      catch (e){
        dispatch(createFailureAction("UpdateError")); 
       return;
      }
    })
    }
    return {ReleaseStatus,FetchReleaseManifest}

}


